import { render } from "./totp_form.vue?vue&type=template&id=5be73abd"
import script from "./totp_form.js?vue&type=script&lang=js"
export * from "./totp_form.js?vue&type=script&lang=js"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__